/* eslint-disable */
import React, { createContext, useMemo } from "react";
import { ReactReportContext } from "@sa/rep-react";

export type ReportRendererProps = {
  componentId: string;
};

export const ReportRenderer: React.FC<ReportRendererProps> = ({componentId}) => {
    const context = React.useContext(ReactReportContext);
    const component = useMemo(() => context.getComponent(componentId), [context, componentId]); 
    return component;
};
